import { Typography as MuiTypography, Tooltip as MuiTooltip, styled, withStyles } from '@material-ui/core';

import { COLORS } from 'theme/constants';

export const Tooltip = withStyles({
  tooltip: {
    minWidth: '280px',
    backgroundColor: COLORS.builderInputFieldBg,
    border: `1px solid ${COLORS.builderButtonColor}`,
    padding: '16px',
    borderRadius: '8px',
  },
  arrow: {
    position: 'absolute',
    top: 'calc(50% - 5px)',
    left: 0,
    marginLeft: '-5px',
    width: '10px',
    height: '10px',
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '12px',
      height: '12px',
      transform: 'rotate(-135deg)',
      zIndex: 0,
      top: '-1px',
      left: '-1px',
      color: COLORS.builderButtonColor,
      borderColor: 'currentColor currentColor transparent transparent',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '10px',
      height: '10px',
      backgroundColor: COLORS.builderInputFieldBg,
      transform: 'rotate(45deg)',
      zIndex: 1,
      top: 0,
      left: 0,
    },
  },
})(MuiTooltip);

export const Typography = styled(MuiTypography)({
  fontSize: '14px',
  lineHeight: 1.15,
  fontWeight: 600,
});

export const List = styled('ul')({
  margin: 0,
  padding: 0,
});

export const ListItem = styled('li')({
  display: 'flex',
  alignItems: 'center',
  listStyle: 'none',
  margin: '8px 0',
  fontSize: '12px',
  lineHeight: 1.35,
  fontWeight: 400,
  '& svg': {
    marginRight: '8px',
    width: '14px',
    height: '14px',
    '& circle': {
      r: 4,
    },
  },
});
